export const metersToMiles = (meters: number) => {
  return Math.round(meters / 1609)
}

export const metersToKilometers = (meters: number) => {
  return meters / 1000
}
